/* eslint-disable */

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  isScrollToTopOnNavigateEnabled,
  SCROLL_TO_TOP_ON_NAVIGATE_CHANGE_EVENT,
} from '../helper/scrollToTopFeature';

function ScrollToTop() {
  const location = useLocation();
  const [enabled, setEnabled] = useState(() => isScrollToTopOnNavigateEnabled());

  useEffect(() => {
    const syncEnabled = () => setEnabled(isScrollToTopOnNavigateEnabled());
    window.addEventListener(SCROLL_TO_TOP_ON_NAVIGATE_CHANGE_EVENT, syncEnabled);
    return () => window.removeEventListener(SCROLL_TO_TOP_ON_NAVIGATE_CHANGE_EVENT, syncEnabled);
  }, []);

  useEffect(() => {
    if (!('scrollRestoration' in window.history)) {
      return;
    }
    window.history.scrollRestoration = enabled ? 'manual' : 'auto';
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname, location.search, enabled]);

  return null;
}

export default ScrollToTop;
